'use client'
import { useRef, useState } from 'react'
import { useRouter } from 'next/navigation'
import { Eye, EyeOff } from 'lucide-react'
import ReCAPTCHA from 'react-google-recaptcha'

export default function LoginPage() {
  const [usuario, setUsuario] = useState('')
  const [senha, setSenha] = useState('')
  const [mostrarSenha, setMostrarSenha] = useState(false)
  const [loading, setLoading] = useState(false)
  const recaptchaRef = useRef<ReCAPTCHA>(null)
  const router = useRouter()

  const handleLogin = async (captchaToken: string) => {
    setLoading(true)
    try {
      const res = await fetch('/api/login', {
        method: 'POST',
        body: JSON.stringify({ usuario, senha, captchaToken }),
        headers: { 'Content-Type': 'application/json' },
      })
      const data = await res.json()
      if (res.ok) router.push('/')
      else alert(data.error || 'Erro ao fazer login')
    } catch {
      alert('Erro ao conectar com o servidor.')
    } finally {
      setLoading(false)
    }
  }

  const onSubmit = () => {
    if (!usuario || !senha) return alert('Preencha usuário e senha.')
    recaptchaRef.current?.execute() // ⚡ dispara o reCAPTCHA invisível
  }

  const onCaptchaResolved = (token: string | null) => {
    if (token) handleLogin(token)
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-6 rounded-2xl shadow-md w-full max-w-md mx-4 sm:mx-auto">
        <h1 className="text-xl font-bold mb-4 text-center">Login</h1>
        <input
          type="text"
          placeholder="Usuário"
          value={usuario}
          onChange={(e) => setUsuario(e.target.value)}
          className="border p-2 w-full mb-2 rounded"
        />
        <div className="relative mb-4">
          <input
            type={mostrarSenha ? 'text' : 'password'}
            placeholder="Senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            className="border p-2 w-full rounded pr-10"
          />
          <button
            type="button"
            onClick={() => setMostrarSenha((prev) => !prev)}
            className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500"
          >
            {mostrarSenha ? <EyeOff size={15} /> : <Eye size={15} />}
          </button>
        </div>

        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!}
          size="invisible"
          onChange={onCaptchaResolved}
        />

        <button
          onClick={onSubmit}
          disabled={loading}
          className={`w-full rounded-2xl px-4 py-2 text-white ${
            loading ? 'bg-pink-400' : 'bg-pink-500 hover:bg-pink-600'
          }`}
        >
          {loading ? 'Entrando...' : 'Entrar'}
        </button>
      </div>
    </div>
  )
}
